import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csarray(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
         <meta charset="utf-8" />
      <Sides/>
     
      <Helmet>
   
<title>C# Array tutorial For Beginners</title>
<meta name="description" content="C# array tutorial for beginners.Array in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# array,One-dimensional Array in C#,Multi-dimensional Array in C#" />
<link rel="canonical" href="https://www.codeexampler.com/csharp-array" />
</Helmet>

<div className='lg:pl-56'>
    <h1 className="m-4 mh1">CSharp(C#) Array Tutorial</h1>
    <div className="first">
        <a href="/csharp-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        <div>
    <p className="mt-4 para">1, Array in C# is a collection of similar type of data and stored in manually consecutively under one name<br/>
2, The index number will be different<br/>
3, Main purpose of array is used to handle a large volume of data of some type more easily
</p></div>


<h2 className='headings'>There are 2 types of c# array:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
          <span className="qwerty-4">1</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-5">One-</span>
            <span className="qwerty-2">dimensional </span>
            <span className="qwerty-7">Array</span>
            {"\n"}
            <span className="qwerty-4">2</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-6">Multi-</span>
            <span className="qwerty-2">dimensional </span>
            <span className="qwerty-7">Array</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">How Declare array in CSharp(C#):
</h2>


<h2 className='headings'>This is Basic array style:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
          <span className="qwerty-4">Ex-</span>
            <span className="qwerty-3">&#123;</span>
            <span className="qwerty-5">10</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-5">20</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-5">30</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-5">40 </span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-5">50</span>
            <span className="qwerty-3">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>C# Array Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
          <span className="qwerty-4">Ex-</span>
            <span className="qwerty-6">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-7">[</span>
            <span className="qwerty-2">4</span>
            <span className="qwerty-7">]</span>
            {"\n"}
            <span className="qwerty-6">   int </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-7">[</span>
            <span className="qwerty-2">5</span>
            <span className="qwerty-7">]</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>Initialization array in C# Example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">Int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-7">[</span>
            <span className="qwerty-2">6</span>
            <span className="qwerty-7">]</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-3">&#123;</span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">40</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">30</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">60</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">50</span>
            <span className="qwerty-3">&#125;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6">Int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">&#123;</span>
            <span className="qwerty-3">1</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-3">2</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-3">3</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-3">5</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-3">8</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-3">10</span>
            <span className="qwerty-4">&#125;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">Float</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-7">[] </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-3">&#123;</span>
            <span className="qwerty-1">2.8</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-1"> 20.46</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-1"> 8.6</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-1"> 4.5</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-1"> 46.50</span>
            <span className="qwerty-3">&#125;</span>
            {"\n"}  {"\n"}
           
          </code>
        </pre>
      </div>



<h2 className='headings'>Q-Write a program to input an array of 10 elements and print only even elements in C# array?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-7">array</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-9">int </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-9">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-9"> = </span>
            <span className="qwerty-3">&#123;</span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">25</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">30</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">45</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">50</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">655</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">700</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">855</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">900</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">1055</span>
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">if </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">a </span>
            <span className="qwerty-1">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-1">] </span>
            <span className="qwerty-4">% </span>
            <span className="qwerty-3">2</span>
            <span className="qwerty-1"> == </span>
            <span className="qwerty-3">0</span>
            <span className="qwerty-4">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-7">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-7">10</span>
              {"\n"}
              <span className="qwerty-7">30 </span>
              {"\n"}
              <span className="qwerty-7">50 </span>
              {"\n"}
              <span className="qwerty-7">700</span>
              {"\n"}
              <span className="qwerty-7">900 </span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>




<h2 className='headings'>Q- Write a Programme to input an array of 8 elements and print in reverse in array c#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-9">int </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-9">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-9"> = </span>
            <span className="qwerty-3">&#123;</span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">30</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">40</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">50</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">60</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">70</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">80</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">90</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">100</span>
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-10">8</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-7">;</span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">Reverse </span>
              <span className="qwerty-4">Start </span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-10">8</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">--</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-7">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-7">10</span>
              {"\n"}
              <span className="qwerty-7">20 </span>
              {"\n"}
              <span className="qwerty-7">30 </span>
              {"\n"}
              <span className="qwerty-7">40</span>
              {"\n"}
              <span className="qwerty-7">50 </span>
              {"\n"}
              <span className="qwerty-7">60 </span>
              {"\n"}
              <span className="qwerty-7">70 </span>
              {"\n"}
              <span className="qwerty-7">80 </span>
              {"\n"}
              <span className="qwerty-7">Reverse </span>
              <span className="qwerty-4">Start </span>
              {"\n"}
              <span className="qwerty-4">90</span>
              {"\n"}
              <span className="qwerty-4">80 </span>
              {"\n"}
              <span className="qwerty-4">70 </span>
              {"\n"}
              <span className="qwerty-4">60 </span>
              {"\n"}
              <span className="qwerty-4">50 </span>
              {"\n"}
              <span className="qwerty-4">40 </span>
              {"\n"}
              <span className="qwerty-4">30 </span>
              {"\n"}
              <span className="qwerty-4">20 </span>
              {"\n"}
              <span className="qwerty-4">10 </span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to input an array of 10 elements and print in maximum in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-9">int </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-7">Maximum</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-9">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-9"> = </span>
            <span className="qwerty-3">&#123;</span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">40</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">20</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">80</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">90</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">45</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">68</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">60</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">88</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">24</span>
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-7">;</span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">Maximum</span>
            <span className="qwerty-4"> no</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">maximum</span>
            <span className="qwerty-9"> = </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-7">0</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">if</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-7">maximum</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-7">maximum</span>
            <span className="qwerty-9"> = </span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-7">Maximum</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">10</span>
              {"\n"}
              <span className="qwerty-10">40 </span>
              {"\n"}
              <span className="qwerty-10">20 </span>
              {"\n"}
              <span className="qwerty-10">80</span>
              {"\n"}
              <span className="qwerty-10">90 </span>
              {"\n"}
              <span className="qwerty-10">45 </span>
              {"\n"}
              <span className="qwerty-10">68 </span>
              {"\n"}
              <span className="qwerty-10">60 </span>
              {"\n"}
              <span className="qwerty-10">88</span>
              {"\n"}
              <span className="qwerty-10">24 </span>
              {"\n"}
              <span className="qwerty-7">Maximum </span>
              <span className="qwerty-4">no </span>
              {"\n"}
              <span className="qwerty-10">90 </span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csarray;